<template>
    <div>
        <v-chart :options="options"/>
    </div>
</template>
<style>
.echarts {
  width: 300px;
  height: 300px;
}
</style>
<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'

import 'echarts/theme/dark'

export default {
    name : "cmpgraficohalfdonut",
    components: {
        'v-chart': ECharts
    },
    props:[		
        'rotulo',
        'legendas',
		'dados'
    ],
    data () {
        return {
            options : {
                tooltip: {
                    trigger: 'item',
                    formatter: ''
                },
                legend: {
                    orient: 'horizontal',
                    left: -5,
                    top: '30',
                    data: [],
                    textStyle: {
						fontSize: 8
					}
                },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        radius: ['35%', '65%'],
                        startAngle: 180,
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: '14',
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: []
                    }
                ]
            }
        }
    },
    mounted: function () {         
    },    
    computed:{
    },
    watch:{
        legendas(){
            let totaldata = 0
            this.options.legend.data    			= this.legendas;
            this.options.series[0].name 			= this.rotulo;
			this.options.series[0].data 			= this.dados; 

         
            for (let index = 0; index < this.options.series[0].data.length; index++) {
                totaldata =  totaldata + this.options.series[0].data[index].value;
            }

            let parctmp = {
                value: totaldata,
                itemStyle: {
                
                    color: 'none',
                    decal: {
                    symbol: 'none'
                    }
                },
                label: {
                    show: false
                }
            };
            this.options.series[0].data.push(parctmp);
            
        }
    }    
}
</script>